module.exports = __webpack_public_path__ + "static/img/banner2.2043407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2.jpg
// module id = 7/Ek
// module chunks = 1